import { render, staticRenderFns } from "./feefo.vue?vue&type=template&id=77bb79e8&scoped=true&lang=pug&"
import script from "./feefo.vue?vue&type=script&lang=js&"
export * from "./feefo.vue?vue&type=script&lang=js&"
import style0 from "./feefo.vue?vue&type=style&index=0&id=77bb79e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb79e8",
  null
  
)

/* custom blocks */
import block0 from "./feefo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteFeefoStars: require('/home/ubuntu/nuxt/bonkers/releases/20230924131341/components/site/feefo-stars.vue').default,WidgetsTimeago: require('/home/ubuntu/nuxt/bonkers/releases/20230924131341/components/widgets/timeago.vue').default,WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230924131341/components/widgets/image.vue').default})
